import { AxiosHeaders, type AxiosRequestConfig, type AxiosRequestHeaders } from 'axios';

export const redactHeadersInPlace = (
  headers: AxiosRequestConfig['headers'] | AxiosRequestHeaders | undefined
): void => {
  if (!headers) return;

  // Headers that carry bearer/secret credentials and must never reach error
  // logs or Datadog telemetry. Match case-insensitively so callers using any
  // casing (`Authorization`, `authorization`, `X-Auth-Token`, …) are covered.
  const REDACTED_HEADER_KEYS = new Set(['authorization', 'x-auth-token']);

  if (headers instanceof AxiosHeaders) {
    for (const key of REDACTED_HEADER_KEYS) {
      const current = headers.get(key);
      if (current) headers.set(key, '[REDACTED]');
    }
    return;
  }

  const raw = headers as Record<string, unknown>;

  Object.keys(raw).forEach((k) => {
    if (REDACTED_HEADER_KEYS.has(k.toLowerCase())) raw[k] = '[REDACTED]';
  });
};
